<template>
  <section class="metodo-frenkel container py-5" 
    data-aos="zoom-in-up"
    data-aos-duration="1200"
    data-aos-offset="200"
    data-aos-easing="ease-out-cubic"
  >
    <!-- Título -->
    <div class="text-center mb-5">
      <h2 class="metodo-title">{{ content.title }}</h2>
    </div>

    <!-- Contenedor de imagen y acordeón -->
    <div class="row align-items-start">
      <!-- Imagen (arriba en mobile, izquierda en desktop) -->
      <div class="col-12 col-md-7 mb-4 mb-md-0 text-center" data-aos="fade-right" data-aos-delay="150">
        <!-- <img
          :src="currentStep.image" 
          :alt="currentStep.title"
          class="img-fluid rounded shadow-sm metodo-img"
        /> -->
        <transition name="fade-slide" mode="out-in">
          <img
            :key="currentStep.image" 
            :src="currentStep.image" 
            :alt="currentStep.title"
            class="img-fluid rounded shadow-sm metodo-img"
          />
        </transition>
      </div>

      <!-- Acordeón -->
      <div class="col-12 col-md-5" data-aos="fade-left" data-aos-delay="300">
        <h5 class="fw-bold mb-4 text-center text-md-start">{{ content.subtitle }}</h5>
        <div class="accordion" id="metodoAccordion">
          <div
            v-for="(step, index) in content.steps"
            :key="index"
            class="accordion-item"
          >
            <h2 class="accordion-header" :id="'heading' + index">
              <button
                class="accordion-button"
                :class="{ collapsed: activeIndex !== index }"
                type="button"
                @click="setActive(index)"
              >
                <transition name="fade-title" mode="out-in">
                  <span :key="activeIndex === index ? index : 'inactive'">
                    {{ step.title }}
                  </span>
                </transition>
              </button>
            </h2>
            <div
              :id="'collapse' + index"
              class="accordion-collapse"
              :class="{ collapse: activeIndex !== index, show: activeIndex === index }"
              :aria-labelledby="'heading' + index"
              data-bs-parent="#metodoAccordion"
            >
              <transition name="fade-content" mode="out-in">
                <div class="accordion-body" v-if="activeIndex === index" :key="index">
                  {{ step.content }}
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { metodoFrenkel } from '@/assets/data/data.ts'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default {
  name: 'MetodoFrenkel',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  computed: {
    content() {
      return metodoFrenkel[this.selectedLang] || metodoFrenkel['es']
    },
    currentStep() {
      return this.content.steps[this.activeIndex]
    }
  },
  methods: {
    setActive(index) {
      this.activeIndex = index
    }
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true
    });
    setTimeout(() => AOS.refresh(), 300);
  }
}
</script>

<style scoped>
.metodo-title {
  font-family: 'Caveat', cursive;
  font-size: 2rem;
  position: relative;
  display: inline-block;
  cursor: default;
  transition: color 0.3s ease;
}
.metodo-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
}

.metodo-title:hover::after {
  width: 100%;
}

.accordion-button {
  font-weight: 600;
}

.accordion-body {
  font-size: 0.95rem;
  line-height: 1.5;
}

.metodo-img {
  width: 100%;
  height: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.metodo-img:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.fade-title-enter-active, .fade-title-leave-active {
  transition: all 0.3s ease;
}
.fade-title-enter-from {
  opacity: 0;
  transform: translateY(-5px);
}
.fade-title-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.fade-title-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.fade-title-leave-to {
  opacity: 0;
  transform: translateY(5px);
}

@media (max-width: 768px) {
  .metodo-title {
    font-size: 1.6rem;
  }

  .metodo-img {
    max-height: 280px;
  }
}

</style>
